import { FC, HTMLAttributes, MouseEventHandler } from 'react';
import cn from 'classnames';
import { IssuedDataType } from './Types';
import { ReactComponent as ArrowIcon } from 'src/Themes/assets/arrow.svg';
import { ReactComponent as ClearIcon } from 'src/Themes/assets/clear.svg';
import st from './common.module.scss';

interface IPlaceHolderProps extends HTMLAttributes<HTMLDivElement> {
	/** Разрешить очистку результата */
	allowClear?: boolean;
	/** Только для чтения */
	readonly?: boolean;
	/** Флаг ошибки в поле */
	isInvalidate?: boolean;
	/** Текущее значение */
	data: IssuedDataType;
	/** Сброс значения */
	onClear?: (isValue: boolean) => void;
	/** Вызывается при нажатии на стрелочку */
	onOpen?: () => void;
}

/** Компонента отображающая плашку с выбранным значением */
const PlaceHolder: FC<IPlaceHolderProps> = (props) => {
	const {
		readonly,
		allowClear,
		data,
		onOpen,
		onClear,
		className,
		...otherProps
	} = props;

	const onClickHandler: MouseEventHandler = (event) => {
		event.preventDefault();
		event.stopPropagation();
		if (!!onOpen && !readonly) {
			onOpen();
		}
	};

	const onClearHandler: MouseEventHandler = (event) => {
		event.preventDefault();
		event.stopPropagation();
		if (!!onClear && !readonly && allowClear) {
			onClear(true);
		}
	};

	const classes = cn(st.placeholder, className, {
		[st.disabled]: readonly,
	});

	return (
		<div className={classes} {...otherProps}>
			<div className={st.placeholder__Part}>
				{!readonly && <ArrowIcon onClick={onClickHandler} />}
			</div>
			<div className={st.placeholder__Content}>
				<p className="body-font">{data.name}</p>
				<span className="body-xsmall">{data.code}</span>
			</div>
			<div className={st.placeholder__Part}>
				{allowClear && !readonly && (
					<ClearIcon onClick={onClearHandler} />
				)}
			</div>
		</div>
	);
};

export default PlaceHolder;
